import { render, staticRenderFns } from "./video-replay-list.vue?vue&type=template&id=8b9f20ba&"
import script from "./video-replay-list.vue?vue&type=script&lang=js&"
export * from "./video-replay-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports